import {connect} from 'react-redux';

import {ContactCardPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {ModifiersEnum} from '../../../../../srcCommon/inboxes/search/searchModifiersHelpers';
import {VisualContactModel} from '../../../../models/api/visualContactModel';
import {InboxesSearchLocationsEnum} from '../../../../models/url/models/inboxesUrlModel';
import {makeGetContactCardAccount} from '../../../../store/panels/contacts/contactCard/contactCardPanelSelectors';
import {searchByParametersAction} from '../../../../store/stateless/searchActions';
import {ContactCardFooterSearchHistory} from './contactCardFooterSearchHistory';

/*
 * Props.
 */

interface ContactCardFooterSearchHistoryContainerProps {
  panelId: ContactCardPanelId;
  visualContact: VisualContactModel;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactCardFooterSearchHistoryContainerProps>()(() => ({
  account: makeGetContactCardAccount(),
}));

const mapDispatchToProps = makeMapDispatchToProps<ContactCardFooterSearchHistoryContainerProps>()(
  ({visualContact}) => ({
    onSearchContactHistory: () =>
      searchByParametersAction({
        location: InboxesSearchLocationsEnum.GLOBAL,
        query: `history:${visualContact.contact.handle}`,
      }),
    onSearchAccountHistory: (accountAlias: string) =>
      searchByParametersAction({
        location: InboxesSearchLocationsEnum.GLOBAL,
        query: `${ModifiersEnum.ACCOUNT}:${accountAlias}`,
      }),
  }),
);

export const ContactCardFooterSearchHistoryContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactCardFooterSearchHistory);
